import ui from './ui'
import auth from './auth'
import financialCompany from './financialCompany'
import enabledFinancialModules from './enabledFinancialModules'

export default {
  ...auth,
  ...ui,
  ...financialCompany,
  ...enabledFinancialModules
}
